import React from 'react';
import '../styles/PrivacyPolicy.css';


const PrivacyPolicy = () => {
  return (
    <section className="PrivacyPolicy">
      <h2>Privacy Policy</h2>
      <p>This Privacy Policy describes how Pathvizor (“we,” “our,” or “us”) collects, uses, and protects any information you may provide while using the "Pathvizor" app (the “App”). We are committed to ensuring that your privacy is protected.</p>
      <br></br>
      <p>Pathvizor does not provide consumer reports and is not a consumer reporting agency under the Fair Credit Reporting Act. We provide information (address, phone number, property, and more). If you continue using our site then you agree that you have read and agree to our PRIVACY POLICY and TERMS OF USE, which discloses our use of cookies and tracking technologies, and that you will NOT use our site or the information we provide:

(1) to make decisions about or in connection with hiring, promoting, reassigning, or continuing to employ any person, including current or potential volunteers and household employees such as childcare workers, contractors, or home health aides;
(2) to make decisions about or in connection with renting or selling a house, apartment, or other residential property to any person;
(3) to make decisions about or in connection with lending money or extending credit to any person;
(4) in connection with the underwriting of insurance;
(5) for any purpose related to any eligibility determination about a person; or
(6) for any other purposes that would require FCRA compliance.
</p>
      <h4>
      Third-Party Services
      </h4>
      <p>
      Please note that this Privacy Policy does not apply to any third-party services or websites that you may access through the App. We recommend reviewing the privacy policies of any third-party services you interact with.
      </p>
      <h4>
      Analytics
      </h4>
      <p>
      We do not use any analytics services to collect information about how you use the App. We do not track your usage patterns or gather any data related to your interactions with the App.
      </p>
      <h4>
      Contact Us
      </h4>
      <p>
      If you have any questions or concerns about this Privacy Policy or our practices, please contact us at info@pathvizor.com
      </p>
      <h4>
      Changes to This Privacy Policy
      </h4>
      <p>
      We may update this Privacy Policy from time to time to reflect changes to our practices or for other operational, legal, or regulatory reasons. We encourage you to review this Privacy Policy periodically to stay informed about how we are protecting your privacy.
      </p>
      <h4>
      Effective Date
      </h4>
      <p>
      This Privacy Policy was last updated on 6/20/2024.

        By using the "Pathvizor" App, you agree to the terms and conditions of this Privacy Policy. If you do not agree with the terms of this Privacy Policy, please do not use the App.
      </p>
    </section>
  );
}

export default PrivacyPolicy;
